import ThemeButton from '@shared/ui/buttons/ThemeButton';

export default function ThemeButtonImage({
  children,
  name,
  animation = '',
  onClick,
}) {
  return (
    <ThemeButton
      className={`image-btn ${animation}`}
      onClick={onClick}
      block={false}
    >
      <div className="images-block">
        <img src={require(`../../assets/buttons/${name}.svg`)} alt="" />
        <img
          className="img-hover"
          src={require(`../../assets/buttons/${name}-hover.svg`)}
          alt=""
        />
      </div>
      {children}
    </ThemeButton>
  );
}
